module.exports = __webpack_public_path__ + "img/menu-8.4cc34802.webp";